import React, { useContext, useEffect, useState } from "react";
// another components
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
// styled components
import { Col, Row, Table, Empty, Input, Popover, Modal, Button, Select } from "antd"
const { TextArea } = Input;
// models
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";
// icons
import { EyeOutlined, DownloadOutlined, InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { TemplateContext } from "../../../../utils/template_context";
import { DownloadFile } from "../../../../utils/DownloadFile";
import apiDocumentos from "../../../../api/Documentos/api-documentos";
import apiConvocatorias from "../../../../api/Convocatorias/api-convocatorias";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import { ObjNotificaciones } from "../../../../config/notificaciones";
import moment from "moment";
import {
  DatosPostulacionPDF,
  construirCarta,
  construirDeclaracionGC,
  construirDeclaracionResidencia,
  construirRelacion,
  descargarBlob,
  obtenerFirmaB64,
} from '../../../../utils/documentosPostulacionPDF';
import {
  esCartaDeConformacion,
  esDeclaracionDeGrupo,
  esDeclaracionDeResidencia,
  esDeclaracionUnificada,
  esRelacionDeParticipantes,
} from '../../../../utils/documentosGrupoConformado';

import getStorageUser from "../../../../middlewares/GetStorageUser"
import {
  coloresEstado,
  getTipoParticipante,
  getEstadoDocumento,
} from "../../../../utils/postulacionHelpers";
import { ParticipanteCard } from "../../../../components/Shared/ParticipanteCard";

interface IProps {
  postulacion: PostulacionModel;
  descargarArchivo: any;
  lineasConvocatoria: any;
  isBeps?: boolean;
}

const FirmaOPlaceholder = ({ firma }: { firma: string }) => (
  firma ? (
    <img
      src={firma}
      alt="Firma del representante legal"
      style={{ height: "50%", width: "50%", borderTop: "none" }}
    />
  ) : (
    <div style={{ height: "100px", width: "50%", border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#999" }}>
      Sin firma
    </div>
  )
);

const ListaParticipantesOMensaje = ({ participantes, firmasParticipantes }: { participantes: any; firmasParticipantes: any }) => {
  if (!Array.isArray(participantes) || participantes.length === 0) {
    return <p className="text-justify" style={{ fontSize: '12px' }}>No hay participantes registrados.</p>;
  }
  return (
    <div style={{ fontSize: '9px', marginTop: '20px' }}>
      {participantes.map((participante: any, index: number) => (
        <ParticipanteCard key={participante.numeroDocumento ?? String(index)} participante={participante} index={index} firmasParticipantes={firmasParticipantes} />
      ))}
    </div>
  );
};

const tipoArchivoEsperado = (tipo: string | null): string => tipo?.toUpperCase().includes("PRESUPUESTO") ? 'Excel' : 'PDF';

const FormularioSubsanacionMinisterio = ({
  selectedDocumentType,
  setSelectedDocumentType,
  availableDocumentTypes,
  loadingUpload,
  handleUpload,
}: {
  selectedDocumentType: string | null;
  setSelectedDocumentType: (v: string) => void;
  availableDocumentTypes: any[];
  loadingUpload: boolean;
  handleUpload: (e: any) => void;
}) => (
  <div className="mt-4 p-4" style={{ border: '1px solid #d9d9d9', borderRadius: '8px', background: '#f9f9f9', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
    <Row gutter={[16, 16]} align="middle">
      <Col span={24}>
        <span className="font-family-Montserrat-SemiBold d-block mb-2 color-0050A0">Formulario de Subsanación para el Ministerio</span>
      </Col>
      <Col xs={24} md={14}>
        <span className="font-size-12px d-block mb-1">Tipo de documento a subsanar:</span>
        <Select
          placeholder="Seleccione el documento que desea subsanar"
          style={{ width: '100%' }}
          onChange={(value) => setSelectedDocumentType(value)}
          options={availableDocumentTypes}
          className="font-family-Montserrat-Regular"
        />
      </Col>
      <Col xs={24} md={10} className="d-flex align-items-end">
        <div style={{ width: '100%' }}>
          <span className="font-size-12px d-block mb-1">Archivo {tipoArchivoEsperado(selectedDocumentType)}:</span>
          {loadingUpload ? (
            <div className="d-flex align-items-center justify-content-center color-0050A0" style={{ height: '32px' }}>
              <LoadingOutlined className="me-2" />
              <span>Subiendo documento...</span>
            </div>
          ) : (
            <label
              className={`ant-btn button-azul-radius no-margin d-flex align-items-center justify-content-center ${!selectedDocumentType ? 'disabled' : ''}`}
              style={{
                cursor: selectedDocumentType ? 'pointer' : 'not-allowed',
                opacity: selectedDocumentType ? 1 : 0.6,
                height: '32px'
              }}
            >
              <DownloadOutlined style={{ transform: 'rotate(180deg)', marginRight: '8px' }} />
              Seleccionar y Subir {tipoArchivoEsperado(selectedDocumentType)}
              <input
                type="file"
                accept={selectedDocumentType?.toUpperCase().includes("PRESUPUESTO") ? ".xlsx, .xls" : ".pdf"}
                onChange={handleUpload}
                style={{ display: 'none' }}
                disabled={!selectedDocumentType}
              />
            </label>
          )}
        </div>
      </Col>
      <Col span={24}>
        <span className="font-size-11px color-707070">
          <InfoCircleOutlined className="me-1" />
          Primero seleccione el tipo de documento de la lista y luego cargue el archivo {tipoArchivoEsperado(selectedDocumentType)} correspondiente (Máx. 5MB).
        </span>
      </Col>
    </Row>
  </div>
);

export const InformacionPostulacion: React.FC<IProps> = (props: IProps) => {
  const [documento, setDocumento] = useState<string>("");
  const context = useContext(TemplateContext);

  const [showUpload, setShowUpload] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [documentosGenerales, setDocumentosGenerales] = useState<any[]>(props.postulacion.documentos_generales || []);
  const [selectedDocumentType, setSelectedDocumentType] = useState<string | null>(null);
  const [availableDocumentTypes, setAvailableDocumentTypes] = useState<any[]>([]);

  useEffect(() => {
    const technical = (props.postulacion.documentos_tecnicos || []).map((d: any) => ({
      label: `(Técnico) ${d.tipo_documento || d.descripcion}`,
      value: d.tipo_documento || d.descripcion
    }));
    const administrative = (props.postulacion.documentos_administrativos || []).map((d: any) => ({
      label: `(Administrativo) ${d.descripcion}`,
      value: d.descripcion
    }));
    setAvailableDocumentTypes([...technical, ...administrative]);
  }, [props.postulacion]);

  useEffect(() => {
    setDocumentosGenerales(props.postulacion.documentos_generales || []);
    setShowUpload(false);
    setSelectedDocumentType(null);
  }, [props.postulacion]);

  useEffect(() => {
    const checkSchedule = async () => {
      try {
        const res = await apiConvocatorias.getConvocatoriaById(props.postulacion.convocatoria_id);
        if (res?.data?.fechas) {
          for (const element of res.data.fechas) {
            if (element.clave === "Subsanaciones del Ministerio") {
              const now = moment();
              const start = moment(element.valormin);
              const end = moment(element.valormax);
              if (now.isBetween(start, end)) {
                setShowUpload(true);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error checking schedule:", error);
      }
    };
    if (props.postulacion.convocatoria_id) {
      checkSchedule();
    }
  }, [props.postulacion.convocatoria_id]);

  const [openModalDeclaracion, setOpenModalDeclaracion] = useState(false);
  const [datosDeclaracion, setDatosDeclaracion] = useState<any>({});

  const [openModalRelacion, setOpenModalRelacion] = useState(false);
  const [datosRelacion, setDatosRelacion] = useState<any>({});
  const [firmaParticipante, setFirmaParticipante] = useState<string>("");
  const [firmasParticipantes, setFirmasParticipantes] = useState<{ [key: number]: string }>({});

  const [openModalCartaConformacion, setOpenModalCartaConformacion] = useState(false);
  const [datosCartaConformacion, setDatosCartaConformacion] = useState<any>({});

  const [openModalDeclaracionGC, setOpenModalDeclaracionGC] = useState(false);
  const [datosDeclaracionGC, setDatosDeclaracionGC] = useState<any>({});

  const [openModal, setOpenModal] = useState(false);
  const [openModalEscritoVideo, setOpenModalEscritoVideo] = useState(false);
  const [datosEscritoVideo, setDatosEscritoVideo] = useState<any>({});

  const modalAnexo = (datos: any, documentoCompleto?: any) => {
    console.log("=== modalAnexo datos ===", datos);
    console.log("=== modalAnexo documentoCompleto ===", JSON.stringify(documentoCompleto));
    // Si el documento es "Declaración de Residencia" y tiene datos guardados, mostrar modal de declaración
    if (
      esDeclaracionDeResidencia(documentoCompleto) ||
      esDeclaracionUnificada(documentoCompleto)
    ) {
      // El unificado es siempre del grupo; el anterior se llama igual que
      // la declaracion individual, asi que ahi si decide el perfil.
      if (
        esDeclaracionUnificada(documentoCompleto) ||
        (props.postulacion.tipo_participante === "3" &&
          documentoCompleto?.participantes?.length > 0)
      ) {
        setDatosDeclaracionGC(documentoCompleto);
        setOpenModalDeclaracionGC(true);
        // Obtener las firmas de todos los participantes si existen
        (documentoCompleto.participantes ?? []).forEach((participante: any, index: number) => {
          if (participante?.firma) getSignatureParticipante(participante.firma, index);
        });
      } else {
        setDatosDeclaracion(documentoCompleto);
        setOpenModalDeclaracion(true);
        getSignature(documentoCompleto?.firma_declaracion)
      }
    } else if (documentoCompleto?.descripcion === "Relación de participantes de la propuesta" && documentoCompleto?.participantes?.length > 0) {
      setDatosRelacion(documentoCompleto);
      setOpenModalRelacion(true);
      // Obtener las firmas de todos los participantes
      documentoCompleto.participantes.forEach((participante: any, index: number) => {
        if (participante?.firma) {
          getSignatureParticipante(participante.firma, index);
        }
      });
    } else if (
      esCartaDeConformacion(documentoCompleto) &&
      documentoCompleto?.participantes?.length > 0
    ) {
      setDatosCartaConformacion(documentoCompleto);
      setOpenModalCartaConformacion(true);
      // Obtener las firmas de todos los participantes
      documentoCompleto.participantes.forEach((participante: any, index: number) => {
        if (participante?.firma) {
          getSignatureParticipante(participante.firma, index);
        }
      });
    }
    else {
      if (datos && typeof datos === 'string' && datos.trim() !== '') {
        setDocumento(datos)
        setOpenModal(true);
      }
    }
  }

  // Los PDF de documentos administrativos se arman en utils/documentosPostulacionPDF, compartidos
  // con la vista de administración. Aquí solo se aportan los datos propios de esta vista.
  const _datosPDF = (): DatosPostulacionPDF => ({
    lineaConvocatoria: props.postulacion.linea_convocatoria,
    numeroDocumento: props.postulacion.numero_documento_participante,
  });

  // El participante declara con su propio nombre y el tipo de identificación de su sesión
  const _declarante = () => ({
    nombre: props.postulacion.nombre_participante,
    tipoIdentificacion:
      String(user.tipo_identificacion ?? '').split('-')[1] || String(user.tipo_identificacion ?? ''),
  });

  const _fetchFirmaB64 = obtenerFirmaB64;
  const _downloadBlob = descargarBlob;
  const _buildDeclaracionResidencia = (dd: any, firmaB64: string): Blob =>
    construirDeclaracionResidencia(dd, firmaB64, _datosPDF(), _declarante());
  const _buildRelacion = (dd: any, firmasMap: { [k: number]: string }, firmaRepB64: string): Blob =>
    construirRelacion(dd, firmasMap, firmaRepB64, _datosPDF());
  const _buildCarta = (dd: any, firmasMap: { [k: number]: string }, firmaRepB64: string): Blob =>
    construirCarta(dd, firmasMap, firmaRepB64, _datosPDF());
  const _buildDeclaracionGC = (dd: any, firmasMap: { [k: number]: string }, firmaRepB64: string): Blob =>
    construirDeclaracionGC(dd, firmasMap, firmaRepB64, _datosPDF());

  const imprimirPdf = (nombreArchivo: string, tipo: string) => {
    let blob: Blob;
    if (tipo === 'declaracion') blob = _buildDeclaracionResidencia(datosDeclaracion, fileName);
    else if (tipo === 'relacion') blob = _buildRelacion(datosRelacion, firmasParticipantes, firmaParticipante);
    else if (tipo === 'carta') blob = _buildCarta(datosCartaConformacion, firmasParticipantes, firmaParticipante);
    else if (tipo === 'declaracion_gc') blob = _buildDeclaracionGC(datosDeclaracionGC, firmasParticipantes, firmaParticipante);
    else return;
    _downloadBlob(blob, nombreArchivo);
  };

  const [fileName, setFileName] = useState<any>("");

  const getSignature = async (firma) => {
    if (!firma) return;
    try {
      const data = await apiDocumentos.consultarArchivo(firma);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setFileName(base64String);
        }
      }
    } catch (error) {
      console.error("Error al consultar firma:", error);
    }
  };

  const getSignatureParticipante = async (firma: string, index: number) => {
    if (!firma) return;
    try {
      const data = await apiDocumentos.consultarArchivo(firma);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          if (index === 0) {
            setFirmaParticipante(base64String as string);
          }
          // Guardar la firma en el objeto de firmas
          setFirmasParticipantes(prev => ({
            ...prev,
            [index]: base64String as string
          }));
        }
      }
    } catch (error) {
      console.error('Error al obtener la firma del participante:', error);
      if (index === 0) {
        setFirmaParticipante("");
      }
      setFirmasParticipantes(prev => ({
        ...prev,
        [index]: ""
      }));
    }
  };

  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [loadingDownload, setLoadingDownload] = useState<string | null>(null);

  const downloadOnlinePdfBackground = async (datos: any) => {
    setLoadingDownload(datos.descripcion);
    setIsExporting(true);
    try {
      if (esDeclaracionDeResidencia(datos) && !(datos.participantes?.length > 0)) {
        const firmaB64 = await _fetchFirmaB64(datos.firma_declaracion);
        _downloadBlob(_buildDeclaracionResidencia(datos, firmaB64), `Declaracion_Residencia_${props.postulacion.radicado || ''}`);
      } else if (datos.descripcion === "Relación de participantes de la propuesta" && datos.participantes?.length > 0) {
        const firmasMap: {[k: number]: string} = {};
        await Promise.all(datos.participantes.map(async (p: any, i: number) => { if (p.firma) firmasMap[i] = await _fetchFirmaB64(p.firma); }));
        _downloadBlob(_buildRelacion(datos, firmasMap, firmasMap[0] || ''), `Relacion_de_Participantes_${props.postulacion.radicado || ''}`);
      } else if (esCartaDeConformacion(datos) && datos.participantes?.length > 0) {
        const firmasMap: {[k: number]: string} = {};
        await Promise.all(datos.participantes.map(async (p: any, i: number) => { if (p.firma) firmasMap[i] = await _fetchFirmaB64(p.firma); }));
        _downloadBlob(_buildCarta(datos, firmasMap, firmasMap[0] || ''), `Carta_de_Conformacion_de_Grupo_${props.postulacion.radicado || ''}`);
      } else if (esDeclaracionDeGrupo(datos)) {
        const firmasMap: {[k: number]: string} = {};
        await Promise.all(datos.participantes.map(async (p: any, i: number) => { if (p.firma) firmasMap[i] = await _fetchFirmaB64(p.firma); }));
        _downloadBlob(_buildDeclaracionGC(datos, firmasMap, firmasMap[0] || ''), `Declaracion_Residencia_GC_${props.postulacion.radicado || ''}`);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsExporting(false);
      setLoadingDownload(null);
    }
  }

  const handleUpload = async (e: any) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!selectedDocumentType) {
      return ObjNotificaciones.MSG_ERROR("Error", "Debe seleccionar el tipo de documento a subsanar", "error");
    }

    const isBudget = selectedDocumentType.toUpperCase().includes("PRESUPUESTO");
    const maxSize = 5 * 1024 * 1024;

    if (file.size > maxSize) {
      return ObjNotificaciones.MSG_ERROR("Error", "El archivo no debe pesar más de 5MB", "error");
    }

    if (isBudget) {
      const extension = file.name.split('.').pop().toLowerCase();
      const isExcel = extension === 'xlsx' || extension === 'xls' || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type === "application/vnd.ms-excel";
      if (!isExcel) {
        return ObjNotificaciones.MSG_ERROR("Error", "Para el Presupuesto solo se permiten archivos Excel (.xlsx, .xls)", "error");
      }
    } else if (file.type !== "application/pdf") {
      return ObjNotificaciones.MSG_ERROR("Error", "Solo se permiten archivos PDF", "error");
    }

    const formData = new FormData();
    formData.append("archivo", file);
    setLoadingUpload(true);

    try {
      const res = await apiDocumentos.guardarArchivo(formData);
      const filename = res.data || (typeof res === 'string' ? res : null);

      if (!filename) {
        setLoadingUpload(false);
        return ObjNotificaciones.MSG_ERROR("Error", "No se pudo guardar el archivo", "error");
      }

      const nuevosDocumentos = [
        ...documentosGenerales,
        {
          descripcion: selectedDocumentType,
          url_participante: filename,
          fecha_subsanado: moment().format("YYYY-MM-DD HH:mm:ss"),
          subsanado_por: `${user.nombres} ${user.apellidos}`
        }
      ];

      await apiParticipantes.guardarDocumentosGeneralesPostulacion(
        props.postulacion.id_postulacion,
        nuevosDocumentos
      );

      setDocumentosGenerales(nuevosDocumentos);
      setLoadingUpload(false);
      ObjNotificaciones.MSG_SUCCESS("Éxito", "Documento guardado correctamente");
    } catch (error) {
      console.error(error);
      setLoadingUpload(false);
      ObjNotificaciones.MSG_ERROR("Error", "Hubo un problema al guardar el documento", "error");
    }
  };

  const user = getStorageUser()

  // columns
  const columnasDocumentaciontecnicaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 120,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any, record: any, index: number) => (
        <div className="row">
          <div className="col-12">
            {datos.tipo_documento || datos.descripcion}
          </div>
        </div>
      ),
    },
    {
      title: "Nombre del documento",
      width: 300,
      render: (datos: any) => {
        const s = { fontFamily: "Montserrat-Regular", cursor: "pointer" };
        return (() => {
          if (!datos || !("url_participante" in datos || "escrito" in datos)) return <span style={s}>No se cargó un documento</span>;
          if ("url_participante" in datos && datos.url_participante.length > 0) {
            if (datos.url_participante.length > 27) return (
              <Popover content={datos.url_participante} title="Nombre del documento">
                <span style={s}>{`${datos.url_participante.substring(0, 24)}...`}</span>
              </Popover>
            );
            return <span style={s}>{`${datos.url_participante}`}</span>;
          }
          if (datos.tipo_documento === "Escrito y Video" && (datos.escrito || datos.url_video)) return <span style={s}>Diligenciado en el sistema</span>;
          return <span style={s}>No se cargó un documento</span>;
        })();
      }
    },
    {
      title: (
        <div className="row">
          <div className="col-24 justify-content-center">Estado</div>
        </div>
      ),
      width: 100,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        return (
            <>
            {(() => {
              if (datos.checkaceptartecnico === undefined) return (
                <div className="justify-content-center"><span>Inscrito sin revisar</span></div>
              );
              const estado = datos.checkaceptartecnico === true ? "Aceptado" : "Rechazado";
              return (
                <div className="row">
                  <div className="col-12 justify-content-center">
                    <span style={{ color: coloresEstado[estado] }}>{estado}</span>
                  </div>
                </div>
              );
            })()}
            </>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <div>Acciones</div>
          <div style={{ display: "flex", justifyContent: "center", gap: "16px", fontSize: "11px", color: "#666" }}>
            <span>Ver</span>
            <span>Desc.</span>
          </div>
        </div>
      ),
      width: 130,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        const isEscritoVideo = datos.tipo_documento === "Escrito y Video";
        const hasContent = (datos.url_participante && datos.url_participante !== "") || (isEscritoVideo && (datos.escrito || datos.url_video));

        if (datos && hasContent) {
          return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px" }}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <EyeOutlined
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (isEscritoVideo) {
                      setDatosEscritoVideo(datos);
                      setOpenModalEscritoVideo(true);
                    } else {
                      setOpenModal(true);
                      setDocumento(datos.url_participante);
                    }
                  }}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                {!isEscritoVideo && (
                  <DownloadOutlined
                    style={{ cursor: "pointer" }}
                    onClick={() => DownloadFile(datos.url_participante)}
                  />
                )}
              </div>
            </div>
          );
        }
      },
    },
  ];
  //  columns table documentación técnica
  const columnasDocumentacionadministrativaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 380,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => (
        <div className="row">
          <div className="col-12">{datos.descripcion}</div>
        </div>
      ),
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Info doc
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Popover
                  title="Trazabilidad del documento"
                  content={
                    <div style={{ fontSize: 'small' }}>
                      <p className="font-color-6435C9">Fecha subsanado: <span style={{ fontWeight: 'bold' }}>{datos.fecha_subsanado}</span></p>
                      <p className="font-color-6435C9">Subsanado por: <span style={{ fontWeight: 'bold' }}>{datos.subsanado_por}</span></p>
                      {datos.url_anterior && (
                        <p className="font-color-6435C9">Ver anterior: {' '}
                          <span style={{ fontWeight: 'bold' }}>
                            <EyeOutlined
                              onClick={() => {
                                setOpenModal(true);
                                setDocumento(datos.url_anterior);
                              }} />
                          </span>
                        </p>)
                      }
                    </div>
                  }>
                  <InfoCircleOutlined />
                </Popover>
              </Col>
            </Row>
        );
      },
    },
    {
      title: (
        <div className="width-100">
          <div className="col-12 justify-content-center">Estado</div>
        </div>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
            <div className="width-100">
              <div className="col-12 justify-content-center">
                {getEstadoDocumento(datos)}
              </div>
            </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <div>Acciones</div>
          <div style={{ display: "flex", justifyContent: "center", gap: "16px", fontSize: "11px", color: "#666" }}>
            <span>Ver</span>
            <span>Desc.</span>
          </div>
        </div>
      ),
      width: 130,
      render: (datos: any, record: any, index: number) => {
        // Determinar el documento a visualizar según el tipo
        const hasParticipantes = datos?.participantes?.length > 0;
        const esDeclaracion =
          esDeclaracionDeResidencia(datos) || esDeclaracionUnificada(datos);
        const esRelacion = esRelacionDeParticipantes(datos);
        const esCarta = esCartaDeConformacion(datos);
        const esDocumentoEspecial = (esDeclaracion || esRelacion || esCarta) && (hasParticipantes || datos?.firma_declaracion);
        const tieneDocumento = datos?.url_participante || esDocumentoEspecial;
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              {tieneDocumento && (
                <EyeOutlined
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    modalAnexo(datos.url_participante, datos)
                  }}
                />
              )}
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              {(datos?.url_participante || esDocumentoEspecial) ? (
                (() => {
                  if (loadingDownload === datos.descripcion) return <LoadingOutlined />;
                  return (
                    <DownloadOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (datos.url_participante) {
                          DownloadFile(datos.url_participante);
                        } else {
                          downloadOnlinePdfBackground(datos);
                        }
                      }}
                    />
                  );
                })()
              ) : null}
            </div>
          </div>
        );
      },
    },
  ];

  const columnasDocumentacionGeneralModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 100,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => (
        <div className="row">
          <div className="col-12">{datos.descripcion}</div>
        </div>
      ),
    },
    {
      title: "Nombre del documento",
      width: 100,
      render: (datos: any, datos2: any, index: number) => {
        const esEscritoVideo = datos.tipo_documento === "Escrito y Video";
        const tieneContenido = datos.escrito || datos.url_video;
        const etiquetaContenido = tieneContenido ? "Diligenciado en el sistema" : "No se cargó información";
        return (
          <>
            {esEscritoVideo ? (
              <span>{etiquetaContenido}</span>
            ) : (
              <span>{datos.url_participante}</span>
            )}
          </>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Info doc
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Popover
                  title="Trazabilidad del documento"
                  content={
                    <div style={{ fontSize: 'small' }}>
                      <p className="font-color-6435C9">Fecha subsanado: <span style={{ fontWeight: 'bold' }}>{datos.fecha_subsanado}</span></p>
                      <p className="font-color-6435C9">Subsanado por: <span style={{ fontWeight: 'bold' }}>{datos.subsanado_por}</span></p>
                      {datos.url_anterior && (
                        <p className="font-color-6435C9">Ver anterior: {' '}
                          <span style={{ fontWeight: 'bold' }}>
                            <EyeOutlined
                              onClick={() => {
                                setOpenModal(true);
                                setDocumento(datos.url_anterior);
                              }} />
                          </span>
                        </p>)
                      }
                    </div>
                  }>
                  <InfoCircleOutlined />
                </Popover>
              </Col>
            </Row>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <div>Acciones</div>
          <div style={{ display: "flex", justifyContent: "center", gap: "16px", fontSize: "11px", color: "#666" }}>
            <span>Ver</span>
            <span>Desc.</span>
          </div>
        </div>
      ),
      width: 130,
      render: (datos: any, record: any, index: number) => {
        // Determinar el documento a visualizar según el tipo
        const hasParticipantes = datos?.participantes?.length > 0;
        const esDeclaracion =
          esDeclaracionDeResidencia(datos) || esDeclaracionUnificada(datos);
        const esRelacion = esRelacionDeParticipantes(datos);
        const esCarta = esCartaDeConformacion(datos);
        const esDocumentoEspecial = (esDeclaracion || esRelacion || esCarta) && (hasParticipantes || datos?.firma_declaracion);
        const tieneDocumento = datos?.url_participante || esDocumentoEspecial;
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              {tieneDocumento && (
                <EyeOutlined
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    modalAnexo(datos.url_participante, datos)
                  }}
                />
              )}
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              {(datos?.url_participante || esDocumentoEspecial) ? (
                (() => {
                  if (loadingDownload === datos.descripcion) return <LoadingOutlined />;
                  return (
                    <DownloadOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (datos.url_participante) {
                          DownloadFile(datos.url_participante);
                        } else {
                          downloadOnlinePdfBackground(datos);
                        }
                      }}
                    />
                  );
                })()
              ) : null}
            </div>
          </div>
        );
      },
    },
  ]
  //   columns table enlaces
  const columnaslinksModal = [
    {
      title: "URL",
      width: 260,
      render: (datos: any, record: any, index: number) => {
        if (datos?.url) {
          return (
            <div className="row">
              <div className="col-12">
                <a target="_blank" href={datos.url}>
                  {datos.url}
                </a>
              </div>
            </div>
          );
        } else {
          return (
            <div className="row">
              <div className="col-12">
                <a target="_blank" href={"Sin Información"}>
                  Sin Información
                </a>
              </div>
            </div>
          );
        }
      },
    },
  ];

  return (
    <>
      <div
        className="row"
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <div
          className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          Nombre representante
        </div>
        <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
          {props.postulacion.nombre_participante}
        </div>
        {props.isBeps ? null : (
          <>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Tipo de participante
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
              style={{ background: "#F0F6FB" }}
            >
              {getTipoParticipante(props.postulacion.tipo_participante)}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Línea
            </div>
            <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
              {props.postulacion.linea_convocatoria}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Categorías
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
              style={{ background: "#F0F6FB" }}
            >
              {props.postulacion.categoria_linea_convocatoria}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Estado
            </div>
            <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
              {props.postulacion.estado}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Observaciones
            </div>
            <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
              {props.postulacion.observaciones}
            </div>
          </>
        )}
        {props.postulacion.documentos_tecnicos !== null &&
          props.postulacion.documentos_tecnicos.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Documentos Técnicos
            </span>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentaciontecnicaModal}
              scroll={{ x: 750 }}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_tecnicos}
            />
          </div>
        ) : null}
        {props.postulacion.documentos_administrativos !== null &&
          props.postulacion.documentos_administrativos.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Documentos administrativos
            </span>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentacionadministrativaModal}
              scroll={{ x: 800 }}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_administrativos}
            />
          </div>
        ) : null}
        {props.postulacion.linea_convocatoria?.toString().toUpperCase().includes("LEP") && (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Subsanaciones del Ministerio
            </span>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentacionGeneralModal}
              scroll={{ x: 750 }}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={documentosGenerales}
            />
            {showUpload && (
              <div className="mt-4 p-4" style={{ border: '1px solid #d9d9d9', borderRadius: '8px', background: '#f9f9f9', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                <Row gutter={[16, 16]} align="middle">
                  <Col span={24}>
                    <span className="font-family-Montserrat-SemiBold d-block mb-2 color-0050A0">Formulario de Subsanación para el Ministerio</span>
                  </Col>
                  <Col xs={24} md={14}>
                    <span className="font-size-12px d-block mb-1">Tipo de documento a subsanar:</span>
                    <Select
                      placeholder="Seleccione el documento que desea subsanar"
                      style={{ width: '100%' }}
                      onChange={(value) => setSelectedDocumentType(value)}
                      options={availableDocumentTypes}
                      className="font-family-Montserrat-Regular"
                    />
                  </Col>
                  <Col xs={24} md={10} className="d-flex align-items-end">
                    <div style={{ width: '100%' }}>
                      <span className="font-size-12px d-block mb-1">Archivo {selectedDocumentType?.toUpperCase().includes("PRESUPUESTO") ? 'Excel' : 'PDF'}:</span>
                      {loadingUpload ? (
                        <div className="d-flex align-items-center justify-content-center color-0050A0" style={{ height: '32px' }}>
                          <LoadingOutlined className="me-2" />
                          <span>Subiendo documento...</span>
                        </div>
                      ) : (
                        <label
                          className={`ant-btn button-azul-radius no-margin d-flex align-items-center justify-content-center ${!selectedDocumentType ? 'disabled' : ''}`}
                          style={{
                            cursor: selectedDocumentType ? 'pointer' : 'not-allowed',
                            opacity: selectedDocumentType ? 1 : 0.6,
                            height: '32px'
                          }}
                        >
                          <DownloadOutlined style={{ transform: 'rotate(180deg)', marginRight: '8px' }} />
                          Seleccionar y Subir {selectedDocumentType?.toUpperCase().includes("PRESUPUESTO") ? 'Excel' : 'PDF'}
                          <input
                            type="file"
                            accept={selectedDocumentType?.toUpperCase().includes("PRESUPUESTO") ? ".xlsx, .xls" : ".pdf"}
                            onChange={handleUpload}
                            style={{ display: 'none' }}
                            disabled={!selectedDocumentType}
                          />
                        </label>
                      )}
                    </div>
                  </Col>
                  <Col span={24}>
                    <span className="font-size-11px color-707070">
                      <InfoCircleOutlined className="me-1" />
                      Primero seleccione el tipo de documento de la lista y luego cargue el archivo {selectedDocumentType?.toUpperCase().includes("PRESUPUESTO") ? 'Excel' : 'PDF'} correspondiente (Máx. 5MB).
                    </span>
                  </Col>
                </Row>
              </div>

            )}
          </div>
        )}
        {props.postulacion?.links !== null && props.postulacion?.links.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Enlaces del proyecto
            </span>
            <Table
              pagination={false}
              style={{ paddingTop: "16px" }}
              columns={columnaslinksModal}
              scroll={{ x: 500 }}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.links}
            />
          </div>
        ) : null}
      </div>
      {openModal &&
        <ModalVisualizarDocumentos
          visualizar={openModal}
          setVisualizar={setOpenModal}
          state={{ documento }}
        />
      }
      <Modal
        title={
          <div className="font-family-Montserrat-Bold font-size-22px color-0050A0 d-flex align-items-center">
            <EyeOutlined style={{ marginRight: '12px', fontSize: '26px' }} />
            Visualizar Escrito y Video
          </div>
        }
        visible={openModalEscritoVideo}
        onCancel={() => setOpenModalEscritoVideo(false)}
        width={900}
        centered
        footer={[
          <Button
            key="close"
            onClick={() => setOpenModalEscritoVideo(false)}
            className="button-blanco-radius"
          >
            Cerrar
          </Button>
        ]}
      >
        <div className="p-3">
          <div className="mb-4">
            <span className="font-family-Montserrat-SemiBold font-size-16px mb-2 d-block color-707070">
              Escrito o Narración de la Propuesta:
            </span>
            <TextArea
              rows={12}
              value={datosEscritoVideo?.escrito}
              disabled
              className="mt-1 font-family-Montserrat-Regular"
              style={{ borderRadius: '8px', padding: '12px', border: '1px solid #d9d9d9', color: 'rgba(0, 0, 0, 0.85)', backgroundColor: '#f5f5f5' }}
            />
          </div>
          <div className="mt-5">
            <span className="font-family-Montserrat-SemiBold font-size-16px mb-2 d-block color-707070">
              URL del video de soporte:
            </span>
            <div className="mt-1 p-3" style={{ border: '1px solid #d9d9d9', borderRadius: '8px', backgroundColor: '#f5f5f5' }}>
              <a
                href={datosEscritoVideo?.url_video}
                target="_blank"
                rel="noopener noreferrer"
                className="font-family-Montserrat-Regular"
                style={{ color: '#0050A0', textDecoration: 'underline' }}
              >
                {datosEscritoVideo?.url_video}
              </a>
            </div>
          </div>
        </div>
      </Modal>
      {openModalDeclaracion && (
        <Modal
          style={{ top: 20, zIndex: isExporting ? -999 : 3 }}
          wrapProps={{ style: isExporting ? { position: 'fixed', left: '-9999px' } : undefined }}
          mask={!isExporting}
          visible={openModalDeclaracion}
          footer={[
            <Button
              key="download"
              onClick={() => imprimirPdf(`Declaracion_Residencia_${props.postulacion.radicado || ''}`, 'declaracion')}
              className="button-blanco-radius"
            >
              Descargar PDF
            </Button>,
            <Button
              key="close"
              onClick={() => setOpenModalDeclaracion(false)}
              className="button-blanco-radius"
            >
              Cerrar
            </Button>
          ]}
          closable={true}
          onCancel={() => setOpenModalDeclaracion(false)}
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom_declaracion" className="document-page">
              <h3 className="text-center">
                DECLARACIÓN JURAMENTADA DE RESIDENCIA
              </h3>

              <p className="text-justify">
                Señores, <br />
                {props.postulacion.linea_convocatoria?.toString().includes('SM -') ? (
                  <>
                    <strong>Convocatoria Estímulos a los Talentos y Liderazgos de las Mujeres</strong> <br />
                    Secretaría de las Mujeres <br />
                  </>
                ) : (
                  <>
                    <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                    Secretaría de Cultura Ciudadana <br />
                  </>
                )}
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <br />
              <p className="text-justify">
                Yo, <strong>{props.postulacion.nombre_participante}</strong>, identificado(a) con{" "}
                <strong> {user.tipo_identificacion?.split('-')[1]}</strong> número{" "}
                <strong> {props.postulacion.numero_documento_participante || ""}</strong>, manifiesto bajo{" "}
                gravedad de juramento que mi lugar de residencia es{" "}
                <strong>{datosDeclaracion?.ciudad || ""} </strong>
                y lo ha sido durante los
                últimos{" "}
                <strong>{datosDeclaracion?.anos_residencia || ""}</strong>{" "}
                años.
              </p>
              <br />
              <p><strong>Dirección: {datosDeclaracion?.direccion || ""}</strong></p>
              <p><strong>Ciudad: {datosDeclaracion?.ciudad || ""}</strong></p>
              {datosDeclaracion?.ciudad == "MEDELLÍN" && (
                <p><strong>Comuna: {datosDeclaracion?.comuna || ""}</strong></p>
              )}
              <p><strong>Correo electrónico: {datosDeclaracion?.correo || ""}</strong> </p>
              <p><strong>Teléfono: {datosDeclaracion?.telefono || ""}</strong> </p>

              <br />

              <p className="text-right">
                En constancia, se firma a los {datosDeclaracion?.fecha_firma}
                <img
                  src={fileName}
                  style={{
                    height: "50%",
                    width: "50%",
                    borderTop: "none",
                  }}
              alt=""
              />
              </p>
              <br /><br />
            </div>
          </div>
        </Modal>
      )}
      {openModalRelacion && (
        <Modal
          style={{ top: 20, zIndex: isExporting ? -999 : 3 }}
          wrapProps={{ style: isExporting ? { position: 'fixed', left: '-9999px' } : undefined }}
          mask={!isExporting}
          visible={openModalRelacion}
          footer={[
            <Button
              key="download"
              onClick={() => imprimirPdf(`Relacion_de_Participantes_${props.postulacion.radicado || ''}`, 'relacion')}
              className="button-blanco-radius"
            >
              Descargar PDF
            </Button>,
            <Button
              key="close"
              onClick={() => setOpenModalRelacion(false)}
              className="button-blanco-radius"
            >
              Cerrar
            </Button>
          ]}
          width={900}
          maskClosable={true}
          onCancel={() => setOpenModalRelacion(false)}
          maskStyle={{
            zIndex: 3,
            background: "rgb(12, 164, 93)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom_relacion" className="document-page">
              <h3 className="text-center">
                RELACIÓN DE PARTICIPANTES DE LA PROPUESTA
              </h3>
              <p className="text-justify">
                Señores, <br />
                <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                Secretaría de Cultura Ciudadana <br />
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <p className="text-justify">
                <strong>
                  Asunto: Relación de participantes para propuestas de personas jurídicas
                </strong>
              </p>
              <p className="text-justify">
                A continuación, relacionamos las personas que desarrollarán la propuesta {" "}
                <strong>{datosRelacion?.datos_empresa?.razon_social}</strong> presentada en la {" "}
                <strong>{props.postulacion.linea_convocatoria}</strong>.
              </p>
              <div>
                {datosRelacion?.participantes && Array.isArray(datosRelacion.participantes) && datosRelacion.participantes.length > 0 ? (
                  <div style={{ fontSize: '9px', marginTop: '20px' }}>
                    {datosRelacion.participantes.map((participante: any, index: number) => {
                      return <ParticipanteCard key={participante.numeroDocumento ?? String(index)} participante={participante} index={index} firmasParticipantes={firmasParticipantes} />;
                    })}
                  </div>
                ) : (
                  <p className="text-justify" style={{ fontSize: '12px' }}>
                    No hay participantes registrados.
                  </p>
                )}
              </div>
              <div>
                <p className="text-right">
                  En constancia, se firma en Medellín a los {datosRelacion.fecha_firma}.
                  <br />
                  <br />
                  <br />
                  {firmaParticipante ? (
                    <img
                      src={firmaParticipante}
                      alt="Firma del representante legal"
                      style={{
                        height: "50%",
                        width: "50%",
                        borderTop: "none",
                      }}
                    />
                  ) : (
                    <div style={{ height: "100px", width: "50%", border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#999" }}>
                      Sin firma
                    </div>
                  )}
                  <br />
                  <strong>
                    {datosRelacion.participantes[0].nombresApellidos}
                  </strong>
                  <br />
                  Representante legal
                </p>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {openModalCartaConformacion && (
        <Modal
          style={{ top: 20, zIndex: isExporting ? -999 : 3 }}
          wrapProps={{ style: isExporting ? { position: 'fixed', left: '-9999px' } : undefined }}
          mask={!isExporting}
          visible={openModalCartaConformacion}
          footer={[
            <Button
              key="download"
              onClick={() => imprimirPdf(`Carta_de_Conformacion_de_Grupo_${props.postulacion.radicado || ''}`, 'carta')}
              className="button-blanco-radius"
            >
              Descargar PDF
            </Button>,
            <Button
              key="close"
              onClick={() => setOpenModalCartaConformacion(false)}
              className="button-blanco-radius"
            >
              Cerrar
            </Button>
          ]}
          width={900}
          maskClosable={true}
          onCancel={() => setOpenModalCartaConformacion(false)}
          maskStyle={{
            zIndex: 3,
            background: "rgb(12, 164, 93)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom_carta" className="document-page">
              <h3 className="text-center">
                CARTA DE CONFORMACIÓN DE GRUPO
              </h3>
              <p className="text-justify">
                Señores, <br />
                <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                Secretaría de Cultura Ciudadana <br />
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <p className="text-justify">
                Los suscritos abajo firmantes, manifestamos por medio de este documento, que conformamos el grupo {" "}
                <strong>
                  {datosCartaConformacion?.participantes[0].nombreGrupo}
                  {" "}
                </strong> y que hemos decidido participar en la línea {" "}
                <strong>{props.postulacion.linea_convocatoria}</strong> {" "}
                para lo cual afirmamos conocer las condiciones generales y específicas de participación.
              </p>
              <p className="text-justify">
                Para efectos del proceso de la convocatoria, designamos como representante del grupo a {" "}
                <strong> {datosCartaConformacion?.participantes[0].nombresApellidos} </strong> {" "}
                identificado(a) con{" "}
                <strong> {datosCartaConformacion?.participantes[0].tipoDocumento}</strong> número{" "}
                <strong> {datosCartaConformacion?.participantes[0].numeroDocumento}</strong>, quien está expresamente facultado(a) para firmar,{" "}
                presentar la propuesta, y en caso de resultar beneficiarios de un estímulo, firmar los
                documentos necesarios y tomar todas las decisiones que fueren necesarias.
              </p>
              <p className="text-justify">
                Además, manifestamos bajo gravedad de juramento que ninguno de los integrantes del  grupo relacionados a continuación, incluido el representante, está incurso en las limitantes  establecidas en la convocatoria.
              </p>
              <div>
                {datosCartaConformacion?.participantes && Array.isArray(datosCartaConformacion.participantes) && datosCartaConformacion.participantes.length > 0 ? (
                  <div style={{ fontSize: '9px', marginTop: '20px' }}>
                    {datosCartaConformacion.participantes.map((participante: any, index: number) => {
                      return <ParticipanteCard key={participante.numeroDocumento ?? String(index)} participante={participante} index={index} firmasParticipantes={firmasParticipantes} />;
                    })}
                  </div>
                ) : (
                  <p className="text-justify" style={{ fontSize: '12px' }}>
                    No hay participantes registrados.
                  </p>
                )}
              </div>
              <div>
                <p className="text-right">
                  En constancia, se firma en Medellín a los {datosCartaConformacion?.fecha_firma}.
                  <br />
                  <br />
                  <br />
                  {firmaParticipante ? (
                    <img
                      src={firmaParticipante}
                      alt="Firma del representante legal"
                      style={{
                        height: "50%",
                        width: "50%",
                        borderTop: "none",
                      }}
                    />
                  ) : (
                    <div style={{ height: "100px", width: "50%", border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#999" }}>
                      Sin firma
                    </div>
                  )}
                  <br />
                  <strong>
                    {datosCartaConformacion.participantes[0].nombresApellidos}
                  </strong>
                  <br />
                  Representante del grupo
                </p>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {openModalDeclaracionGC && (
        <Modal
          style={{ top: 20, zIndex: isExporting ? -999 : 3 }}
          wrapProps={{ style: isExporting ? { position: 'fixed', left: '-9999px' } : undefined }}
          mask={!isExporting}
          visible={openModalDeclaracionGC}
          footer={[
            <Button
              key="download"
              onClick={() => imprimirPdf(`Declaracion_Residencia_GC_${props.postulacion.radicado || ''}`, 'declaracion_gc')}
              className="button-blanco-radius"
            >
              Descargar PDF
            </Button>,
            <Button
              key="close"
              onClick={() => setOpenModalDeclaracionGC(false)}
              className="button-blanco-radius"
            >
              Cerrar
            </Button>
          ]}
          width={900}
          maskClosable={true}
          onCancel={() => setOpenModalDeclaracionGC(false)}
          maskStyle={{
            zIndex: 3,
            background: "rgb(12, 164, 93)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom_declaracion_gc" className="document-page">
              <h3 className="text-center">
                DECLARACIÓN JURAMENTADA DE RESIDENCIA PARA GRUPOS CONFORMADOS
              </h3>
              <p className="text-justify">
                Señores, <br />
                <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                Secretaría de Cultura Ciudadana <br />
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <p className="text-justify">
                Los suscritos abajo firmantes, manifestamos por medio de este documento, que conformamos el grupo {" "}
                <strong>
                  {datosDeclaracionGC?.participantes[0].nombreGrupo}
                  {" "}
                </strong> y que hemos decidido participar en la línea {" "}
                <strong>{props.postulacion.linea_convocatoria}</strong> {" "}
                para lo cual afirmamos conocer las condiciones generales y específicas de participación.
              </p>
              <p className="text-justify">
                Para efectos del proceso de la convocatoria, designamos como representante del grupo a {" "}
                <strong> {datosDeclaracionGC?.participantes[0].nombresApellidos} </strong> {" "}
                identificado(a) con{" "}
                <strong> {datosDeclaracionGC?.participantes[0].tipoDocumento}</strong> número{" "}
                <strong> {datosDeclaracionGC?.participantes[0].numeroDocumento}</strong>, quien está expresamente facultado(a) para firmar,{" "}
                presentar la propuesta, y en caso de resultar beneficiarios de un estímulo, firmar los
                documentos necesarios y tomar todas las decisiones que fueren necesarias.
              </p>
              <p>
                También, manifestamos que ninguno de los integrantes del grupo está incurso en las limitantes establecidas en la convocatoria.
              </p>
              <p className="text-justify">
                Además, los abajo firmantes, manifestamos la bajo gravedad de juramento, que nuestros lugares de residencia son los que se relacionan a continuación:
              </p>
              <div>
                {datosDeclaracionGC?.participantes && Array.isArray(datosDeclaracionGC.participantes) && datosDeclaracionGC.participantes.length > 0 ? (
                  <div style={{ fontSize: '9px', marginTop: '20px' }}>
                    {datosDeclaracionGC.participantes.map((participante: any, index: number) => {
                      return <ParticipanteCard key={participante.numeroDocumento ?? String(index)} participante={participante} index={index} firmasParticipantes={firmasParticipantes} />;
                    })}
                  </div>
                ) : (
                  <p className="text-justify" style={{ fontSize: '12px' }}>
                    No hay participantes registrados.
                  </p>
                )}
              </div>
              <div>
                <p className="text-right">
                  En constancia, se firma en Medellín a los {datosDeclaracionGC?.fecha_firma}.
                  <br />
                  <br />
                  <br />
                  {firmaParticipante ? (
                    <img
                      src={firmaParticipante}
                      alt="Firma del representante legal"
                      style={{
                        height: "50%",
                        width: "50%",
                        borderTop: "none",
                      }}
                    />
                  ) : (
                    <div style={{ height: "100px", width: "50%", border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#999" }}>
                      Sin firma
                    </div>
                  )}
                  <br />
                  <strong>
                    {datosDeclaracionGC.participantes[0].nombresApellidos}
                  </strong>
                  <br />
                  Representante del grupo
                </p>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
